import React, { useState } from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";

const Step2 = () => {
  const student = JSON.parse(localStorage.getItem("student"));
  const [birthDate, setBirthDate] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSaveBirthDate = async (e) => {
    e.preventDefault();

    if (!student) {
      alert("Student data not found. Please login again.");
      window.location.href = "/login";
      return;
    }

    if (!birthDate) {
      alert("Please select your date of birth.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`http://localhost:3000/api/student-demography/${student.student_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            birth_date: birthDate,
            current_step: "3", // WAJIB
          }),
        }
      );

      if (response.ok) {
        setTimeout(() => {
          window.location.href = "/step3";
        }, 800);
      } else {
        const err = await response.json();
        console.error("Save error:", err);
        alert("Failed to save your birth date.");
      }
    } catch (error) {
      console.error("Error updating birth date:", error);
      alert("Error connecting to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-800 via-blue-700 to-blue-400 text-white px-4">
      
      {/* Progress Bar */}
      <div className="w-full max-w-lg mt-6">
        <ProgressBar step={2} />
      </div>

      {/* Title */}
      <motion.h1
        className="text-3xl md:text-4xl font-extrabold mt-12 mb-8 text-center text-yellow-300 drop-shadow-md"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        What is your date of birth?
      </motion.h1>

      {/* Form */}
      <form
        onSubmit={handleSaveBirthDate}
        className="flex flex-col items-center space-y-6"
      >
        <motion.input
          type="date"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
          className="px-6 py-3 rounded-lg text-gray-800 w-64 text-center focus:ring-2 focus:ring-yellow-300 outline-none text-lg"
          required
          whileFocus={{ scale: 1.05 }}
        />

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          type="submit"
          disabled={loading}
          className={`px-6 py-3 font-semibold rounded-xl shadow-md transition-all duration-300 ${
            loading
              ? "bg-gray-400 text-gray-200 cursor-not-allowed"
              : "bg-yellow-400 text-blue-900 hover:bg-yellow-300"
          }`}
        >
          {loading ? "Saving..." : "Next"}
        </motion.button>
      </form>

      {/* Info */}
      <p className="text-sm text-blue-100 mt-12">
        Please enter your birth date in MM-DD-YYYY format 📅
      </p>
	  
	  {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step2;
